<a class="is-like ">
    <span class="likes-count" *ngIf="viewCount">
        <i class="fas fa-eye"></i>
        {{viewCount}}
    </span>
</a>

<a class="is-like " *ngIf="likeCount">
    <i class="fas fa-heart"></i>
    {{likeCount}}
</a>

<a class="is-like ">
    <span class="likes-count" *ngIf="commentCount">
        <i class="fa fa-comment"></i>
        {{commentCount}}
    </span>
</a>